var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isDev)?_c('div',{class:_vm.cls},[_vm._t("default")],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }